import { React, models, kea, history, resources, selectores, componentToRx, Route, match, withRouter } from "app/main/std";

import { RolList } from "./list/list";
import { RolEdit } from "./edit/edit";

export class RolCatalogo extends React.Component {
    render() {
        return (
            <div>
                <Route exact path="/catalogos/Rol" component={RolList} />
                <Route path="/catalogos/Rol/:id" component={RolEdit} />
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/roles/index.tsx